import { DocumentNode } from 'graphql';
import { useContext, useState, useEffect } from 'react';
import { ApolloQueryResult } from 'apollo-client';
import { AppsyncClientContext } from '../ClientProvider';

export interface UseQueryProps<TVariables> {
  query: DocumentNode;
  variables: TVariables;
  customOnResponse?: Function;
  customOnError?: Function;
}

export interface UseQueryResponse<TDataType> {
  data: TDataType | null;
  error: Error | null;
}

function useQuery<TVariables, TDataType>({
  query,
  variables,
  customOnResponse,
  customOnError,
}: UseQueryProps<TVariables>): UseQueryResponse<TDataType> {
  const appsyncClient = useContext(AppsyncClientContext);
  const [data, setData] = useState<TDataType | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const appsyncPromise: Promise<
      ApolloQueryResult<TDataType>
    > = appsyncClient?.query({ query, variables }) as Promise<
      ApolloQueryResult<TDataType>
    >;
    appsyncPromise
      .then((response: ApolloQueryResult<TDataType>) => {
        setData(response.data);
        if (customOnResponse) customOnResponse(response);
      })
      .catch((err: Error) => {
        setError(err);
        if (customOnError) customOnError(err);
      });
  }, []);

  return {
    data,
    error,
  };
}

export default useQuery;
